import { createSlice } from "@reduxjs/toolkit";

import { addWebSocketCases } from "../helpers/storeAction";
import {
  addNewAgencyFeeData,
  deleteAgencyFee,
  fetchAgencyFeeDatas,
  updateAgencyFee,
} from "../thunks/agencyFeeThunks";

import type { Fee } from "../../utils/types/agencyFee";

interface AgencyFeeListState {
  agencyFeeList: Fee[];
  loading: boolean;
  error: string | null;
  isDataFetched?: boolean;
}

const initialState: AgencyFeeListState = {
  agencyFeeList: [],
  loading: false,
  error: null,
  isDataFetched: false,
};

export const agencyFeeListSlice = createSlice({
  name: "agencyFee",
  initialState,
  reducers: {
    resetDataFetched: (state) => {
      state.isDataFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAgencyFeeDatas.pending, (state) => {
        state.loading = true;
        state.isDataFetched = true;
      })
      .addCase(fetchAgencyFeeDatas.fulfilled, (state, action) => {
        state.agencyFeeList = action.payload || [];
        state.loading = false;
      })
      .addCase(fetchAgencyFeeDatas.rejected, (state, action) => {
        state.error = action.payload as string;
        state.isDataFetched = false;
        state.loading = false;
      });

    builder
      .addCase(updateAgencyFee.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAgencyFee.fulfilled, (state, action) => {
        state.loading = false;
        state.agencyFeeList = state.agencyFeeList.map((fee) => {
          if (fee.agencyFeeId === action.payload?.agencyFeeId) {
            return { ...fee, ...action.payload };
          }
          return fee;
        });
      })
      .addCase(updateAgencyFee.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(deleteAgencyFee.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAgencyFee.fulfilled, (state, action) => {
        state.loading = false;
        state.agencyFeeList = state.agencyFeeList.filter(
          (fee) => fee.agencyFeeId !== action.payload?.id
        );
      })
      .addCase(deleteAgencyFee.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(addNewAgencyFeeData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNewAgencyFeeData.fulfilled, (state, action) => {
        state.loading = false;
        state.agencyFeeList = [action.payload, ...state.agencyFeeList];
      })
      .addCase(addNewAgencyFeeData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });
    addWebSocketCases(builder, "agencyFee", "agencyFeeList");
  },
});

export const { resetDataFetched } = agencyFeeListSlice.actions;
export default agencyFeeListSlice.reducer;
